module.exports = __webpack_public_path__ + "assets/images/icons/action_deposit_icon.e919df243d7cc6736369ab725acc80c8.svg";